module.exports = {
  colors: {
    black: "#000",
    white: "#fff",
    primary: {
      DEFAULT: "#8639ff",
    },
    slate: {
      DEFAULT: "#F8FAFC",
      16: "rgba(248, 250, 252, 0.16)",
      50: "#F8FAFC",
      200: "#E3E8F0",
      300: "#CCD5E0",
      500: "#66748A",
      600: "#4E5B6F",
      700: "#354154",
      800: "#1F293A",
    },
    green: {
      DEFAULT: "#25BF59",
      dark: "#1F6B3C",
      light: "#8AEDAE",
      16: "rgba(47, 195, 98, 0.16)",
      50: "#F0FDF4",
      100: "#DDFBE7",
      500: "#2FC362",
      600: "#25BF59",
      700: "#1D7F3F",
      800: "#16a34a",
      900: "#1B956A",
    },
    red: {
      dark: "#BE451E",
      DEFAULT: "#EA4A4B",
      lighter: "#FDE2E2",
      16: "rgba(234, 74, 75, 0.16)",
      500: "#EA4A4B",
      600: "#D72F31",
      700: "#B52426",
    },
    orange: {
      DEFAULT: "#F4762D",
      dark: "#BE451E",
      lighter: "#FEEDD6",
      16: "rgba(244, 118, 45, 0.16)",
      50: "#FFF7ED",
      100: "#FFE7C2",
      300: "#FB923C",
      400: "#F69348",
      600: "#F4762D",
    },
    violet: {
      DEFAULT: "#702ED6",
      light: "#C6B6FB",
      lighter: "#EDE9FD",
      dark: "#5725A2",
      16: "rgba(112, 46, 214, 0.16)",
      600: "#8141E9",
      700: "#7130D6",
      800: "#5F28B3",
    },
    blue: {
      DEFAULT: "#3B65E7",
      dark: "#2D42AC",
      lighter: "#DCEAFD",
      16: "rgba(59, 101, 231, 0.16)",
      50: "#F0F9FF",
      100: "#CCE9FF",
      700: "#3B65E7",
      800: "#0000FF",
      900: "#2D42AC",
    },
    azure: {
      DEFAULT: "#3BBCE7",
      lighter: "#E6F7FA",
      16: "rgba(59, 188, 231, 0.16)",
      50: "#F0F9FF",
      100: "#CCE9FF",
      200: "#99D9FF",
      300: "#66C2FF",
      600: "#43D0FF",
    },
    gray: {
      200: "#DFDFE2",
    },
    yellow: {
      DEFAULT: "#F1BC1E",
      dark: "#A35812",
      lighter: "#FCF9C6",
      16: "rgba(241, 188, 30, 0.16)",
      600: "#F1BC1E",
    },
  },
};
